import React from 'react'

import CustomFieldTypes from './custom-field-types'
import CustomFields from './custom-fields'
import SystemFields from './system-fields'
import VScroll from "../../../../../gd-components/scrolling/custom-v-scroll/v-scroll"
import {PopoverAddColumnProps} from "../popover"

export type PopoverAddFieldsListProps = {
    section                 : string

    onSelectSection         : func
} & PopoverAddColumnProps

export default class FieldsList extends React.Component<PopoverAddFieldsListProps> {

    render() {
        let component
        switch (this.props.section) {
            case 'new-field':
                component = <CustomFieldTypes {...this.props} />
                break

            case gd.const.fields.groups.CUSTOM_FIELDS:
                component = <CustomFields {...this.props} />
                break

            default:
                component = <SystemFields {...this.props} />
                break
        }

        return (
            <VScroll className="fields-list" containerClass="ui5-popover-menu p-t-10">
                {component}
            </VScroll>
        )
    }
}